import { ProjectBase } from './base-classes/project-base'
import { auth } from './auth.module'

const projectBase = new ProjectBase()

projectBase.state.all.defaultFilter = {
  showAll: false,
  projectReviewerUserInitials: auth.state.user.initials,
  projectOwnerUserInitials: '',
  tags: [],
  orderByColumn: 'projectCode',
  orderByDescending: true
}

const mutations = projectBase.mutations()

mutations.resetFilter = (state) => {
  state.all.currentPage = 1
  state.all.defaultFilter.projectReviewerUserInitials = auth.state.user.initials
  state.all.filter = Object.assign({}, state.all.defaultFilter)
}

export const projectsReviewer = {
  namespaced: true,
  state: projectBase.state,
  actions: projectBase.actions(),
  mutations,
  getters: projectBase.getters()
}



// WEBPACK FOOTER //
// ./src/store/project-reviewer.module.js